import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { FaPen } from "react-icons/fa";
import { MdDeleteForever } from "react-icons/md";
import { FaBoxOpen } from "react-icons/fa";
import { FaBoxesStacked } from "react-icons/fa6";
import { Tabs } from "flowbite-react";

import ReusableDataTable from "../hooks/ReusableDataTable";
import Breadcrumb from "../hooks/Breadcrumb";
import { useSidebar } from "../context/SidebarOpenContext";
import { AuthContext } from "../context/AuthContext";
import SingleBoxing from "../component/order/boxing/SingleBoxing";
import GroupBoxing from "../component/order/boxing/GroupBoxing";

function Boxing() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const Order_id = searchParams.get("id");
    const { user } = useContext(AuthContext);
    const { isSidebarOpen } = useSidebar();

    const [orderData, setOrderData] = useState(null); // will store the full order object

    const breadcrumbItems = [
        { href: "/order", label: "Order" },
        { label: "Boxing" }
    ];

    useEffect(() => {
        if (!user) {
            navigate("/");
        } else if (Order_id) {
            fetchOrderDetails();
        }
    }, [user, navigate, Order_id]);

    const fetchOrderDetails = async () => {
        try {
            const res = await axios.get(`order/orders/${Order_id}`);
            setOrderData(res.data);
        } catch (error) {
            console.error("Error fetching order:", error);
        }
    };

    return (
        <div className={` ${isSidebarOpen ? "p-4 sm:ml-64 bg-content-bg min-h-screen" : "p-4 bg-content-bg min-h-screen"}`}>
            <div className="p-4 rounded-lg dark:border-gray-700 mt-14">
                <div className="p-4 rounded-lg shadow bg-white">
                    <Breadcrumb items={breadcrumbItems} />
                    
                    {orderData?.boxing_type && (
                        <Tabs aria-label="Boxing Tabs" variant="default" className="pt-2">
                            {orderData.boxing_type === "Single" && (
                                <Tabs.Item active title="Single Boxing" icon={FaBoxOpen}>
                                    <SingleBoxing orderid={Order_id} />
                                </Tabs.Item>
                            )}
                            {orderData.boxing_type === "Group" && (
                                <Tabs.Item active title="Group Boxing" icon={FaBoxesStacked}>
                                    <GroupBoxing orderid={Order_id} />
                                </Tabs.Item>
                            )}
                        </Tabs>
                    )}
                </div>
            </div>
        </div>
    );
}

export default Boxing;
